import PropertyTypeCast from './PropertyTypeCast';
export default PropertyTypeCast;